<template>
  <section id="template">
    <div class="modal fade" id="modal-email" tabindex="-2">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <body
            data-v-38e062e2=""
            style="
              background-color: rgb(246, 246, 246);
              font-family: sans-serif;
              -webkit-font-smoothing: antialiased;
              font-size: 14px;
              line-height: 1.4;
              margin: 0px;
              padding: 0px;
              text-size-adjust: 100%;
            "
          >
            <table
              role="presentation"
              border="0"
              cellpadding="0"
              cellspacing="0"
              class="body"
              width="100%"
              bgcolor="#f6f6f6"
              data-v-38e062e2=""
              style="
                border-collapse: separate;
                background-color: rgb(246, 246, 246);
                width: 100%;
              "
            >
              <tr data-v-38e062e2="">
                <td
                  valign="top"
                  data-v-38e062e2=""
                  style="
                    font-family: sans-serif;
                    font-size: 14px;
                    vertical-align: top;
                  "
                >
                  &nbsp;
                </td>
                <td
                  class="container"
                  width="580"
                  valign="top"
                  data-v-38e062e2=""
                  style="
                    font-family: sans-serif;
                    font-size: 14px;
                    vertical-align: top;
                    display: block;
                    max-width: 580px;
                    padding: 10px;
                    width: 580px;
                    margin: 0px auto;
                  "
                >
                  <div
                    class="content"
                    data-v-38e062e2=""
                    style="
                      box-sizing: border-box;
                      display: block;
                      margin: 0px auto;
                      max-width: 580px;
                      padding: 10px;
                    "
                  >
                    <!-- START CENTERED WHITE CONTAINER -->
                    <table
                      role="presentation"
                      class="main"
                      width="100%"
                      data-v-38e062e2=""
                      style="
                        border-collapse: separate;
                        background: rgb(255, 255, 255);
                        border-radius: 3px;
                        width: 100%;
                      "
                    >
                      <!-- START MAIN CONTENT AREA -->
                      <tr data-v-38e062e2="">
                        <td
                          class="wrapper"
                          valign="top"
                          data-v-38e062e2=""
                          style="
                            font-family: sans-serif;
                            font-size: 14px;
                            vertical-align: top;
                            box-sizing: border-box;
                            padding: 20px;
                          "
                        >
                          <table
                            role="presentation"
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            width="100%"
                            data-v-38e062e2=""
                            style="border-collapse: separate; width: 100%"
                          >
                            <tr data-v-38e062e2="">
                              <!-- Hero Image -->
                              <td
                                valign="top"
                                data-v-38e062e2=""
                                style="
                                  font-family: sans-serif;
                                  font-size: 14px;
                                  vertical-align: top;
                                "
                              >
                                <div
                                  class="default-style mb-2"
                                  data-v-38e062e2=""
                                >
                                  <img
                                    class="aspect-ratio"
                                    src="https://marido-image-bucket.s3.amazonaws.com/marido.baner.png"
                                    alt=""
                                    data-v-38e062e2=""
                                    style="max-width: 100%"
                                  />
                                </div>
                                <p
                                  data-v-38e062e2=""
                                  style="
                                    font-family: sans-serif;
                                    font-size: 14px;
                                    font-weight: normal;
                                    margin: 0px 0px 15px;
                                  "
                                >
                                  <br />Hi there,
                                </p>
                                <p
                                  data-v-38e062e2=""
                                  style="
                                    font-family: sans-serif;
                                    font-size: 14px;
                                    font-weight: normal;
                                    margin: 0px 0px 15px;
                                  "
                                >
                                  This email is to inform you that you have
                                  received a new service request as per details
                                  below.
                                </p>
                                <p
                                  data-v-38e062e2=""
                                  style="
                                    font-family: sans-serif;
                                    font-size: 14px;
                                    font-weight: normal;
                                    margin: 0px 0px 15px;
                                  "
                                >
                                  Please let the client know as soon as possible
                                  if you are interested in providing your
                                  services.
                                </p>
                                <p
                                  data-v-38e062e2=""
                                  style="
                                    font-family: sans-serif;
                                    font-size: 14px;
                                    font-weight: normal;
                                    margin: 0px 0px 15px;
                                  "
                                >
                                  Good luck on your projects!
                                </p>
                                <table
                                  id="customers"
                                  style="
                                    font-family: Arial, Helvetica, sans-serif;
                                    border-collapse: collapse;
                                    width: 100%;
                                  "
                                  width="100%"
                                >
                                  <tr>
                                    <th
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                        padding-top: 12px;
                                        padding-bottom: 12px;
                                        text-align: left;
                                        background-color: #fd5631;
                                        color: white;
                                        width: 30%;
                                      "
                                      align="left"
                                      bgcolor="#fd5631"
                                    >
                                      Campo
                                    </th>
                                    <th
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                        padding-top: 12px;
                                        padding-bottom: 12px;
                                        text-align: left;
                                        background-color: #fd5631;
                                        color: white;
                                        width: 70%;
                                      "
                                      align="left"
                                      bgcolor="#fd5631"
                                    >
                                      Valor
                                    </th>
                                  </tr>
                                  <tr>
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      Proyecto
                                    </td>
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      {{ emailContainer.projectTitle }}
                                    </td>
                                  </tr>
                                  <tr
                                    style="background-color: #f2f2f2"
                                    bgcolor="#f2f2f2"
                                  >
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      Project Descripion
                                    </td>
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      {{ emailContainer.projectDescription }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      Fecha de Inicio
                                    </td>
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      {{ emailContainer.projectStartDate }}
                                    </td>
                                  </tr>
                                  <tr
                                    style="background-color: #f2f2f2"
                                    bgcolor="#f2f2f2"
                                  >
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      Cliente
                                    </td>
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      {{ emailContainer.firstName }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      Teléfono
                                    </td>
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      {{ emailContainer.phone }}
                                    </td>
                                  </tr>
                                  <tr
                                    style="background-color: #f2f2f2"
                                    bgcolor="#f2f2f2"
                                  >
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      Correo
                                    </td>
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      {{ emailContainer.email }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      Solicitud
                                    </td>
                                    <td
                                      style="
                                        border: 1px solid #ddd;
                                        padding: 8px;
                                      "
                                    >
                                      {{ emailContainer.description }}
                                    </td>
                                  </tr>
                                </table>
                                <br data-v-38e062e2="" />
                                <table
                                  role="presentation"
                                  border="0"
                                  cellpadding="0"
                                  cellspacing="0"
                                  class="btn btn-secondary"
                                  width="100%"
                                  data-v-38e062e2=""
                                  style="
                                    border-collapse: separate;
                                    box-sizing: border-box;
                                    width: 100%;
                                  "
                                >
                                  <tbody data-v-38e062e2="">
                                    <tr data-v-38e062e2="">
                                      <td
                                        align="center"
                                        valign="top"
                                        data-v-38e062e2=""
                                        style="
                                          font-family: sans-serif;
                                          font-size: 14px;
                                          padding-bottom: 10px;
                                        "
                                      >
                                        <table
                                          role="presentation"
                                          border="0"
                                          cellpadding="0"
                                          cellspacing="0"
                                          data-v-38e062e2=""
                                          style="
                                            border-collapse: separate;
                                            width: auto;
                                          "
                                        >
                                          <tbody data-v-38e062e2="">
                                            <tr data-v-38e062e2="">
                                              <td
                                                valign="top"
                                                align="center"
                                                data-v-38e062e2=""
                                                style="
                                                  font-family: sans-serif;
                                                  font-size: 14px;
                                                  vertical-align: top;
                                                  border-radius: 5px;
                                                  text-align: center;
                                                "
                                              >
                                                <a
                                                  href="https://www.target-innovations.com"
                                                  target="_blank"
                                                  data-v-38e062e2=""
                                                  style="
                                                    border: 1px solid green;
                                                    border-radius: 5px;
                                                    box-sizing: border-box;
                                                    cursor: pointer;
                                                    display: inline-block;
                                                    font-size: 14px;
                                                    font-weight: bold;
                                                    margin: 10px;
                                                    padding: 12px 25px;
                                                    text-decoration: none;
                                                    text-transform: capitalize;
                                                    background-color: green;
                                                    color: rgb(255, 255, 255);
                                                  "
                                                  >Aceptar Solicitud</a
                                                >
                                              </td>
                                              <td
                                                valign="top"
                                                align="center"
                                                data-v-38e062e2=""
                                                style="
                                                  font-family: sans-serif;
                                                  font-size: 14px;
                                                  vertical-align: top;
                                                  border-radius: 5px;
                                                  text-align: center;
                                                "
                                              >
                                                <a
                                                  href="https://www.target-innovations.com"
                                                  target="_blank"
                                                  data-v-38e062e2=""
                                                  style="
                                                    border: 1px solid
                                                      rgb(52, 152, 219);
                                                    border-radius: 5px;
                                                    box-sizing: border-box;
                                                    cursor: pointer;
                                                    display: inline-block;
                                                    font-size: 14px;
                                                    font-weight: bold;
                                                    margin: 10px;
                                                    padding: 12px 25px;
                                                    text-decoration: none;
                                                    text-transform: capitalize;
                                                    background-color: red;
                                                    color: rgb(255, 255, 255);
                                                  "
                                                  >Rechazar Solicitud</a
                                                >
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <!-- END MAIN CONTENT AREA -->
                    </table>
                    <!-- END CENTERED WHITE CONTAINER --><!-- START FOOTER -->
                    <div
                      class="footer"
                      data-v-38e062e2=""
                      style="
                        clear: both;
                        margin-top: 10px;
                        text-align: center;
                        width: 100%;
                      "
                    >
                      <table
                        role="presentation"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        data-v-38e062e2=""
                        style="border-collapse: separate; width: 100%"
                      >
                        <!-- Social Links -->
                        <tr data-v-38e062e2="">
                          <td
                            data-v-38e062e2=""
                            style="text-align: center; vertical-align: middle"
                          >
                            <div data-v-38e062e2="">
                              <div
                                class="social"
                                data-v-38e062e2=""
                                style="display: inline-block; padding: 3px 3px"
                              >
                                <a
                                  href="https://www.facebook.com/LuizBreak/"
                                  target="_blank"
                                  data-v-38e062e2=""
                                  ><img
                                    width="29"
                                    height="29"
                                    src="https://cdn.gifo.wisestamp.com/s/facebook/EE6A2F/58/circle/border.png"
                                    border="0"
                                    data-v-38e062e2=""
                                /></a>
                              </div>
                              <div
                                class="social"
                                data-v-38e062e2=""
                                style="display: inline-block; padding: 3px 3px"
                              >
                                <a
                                  href="https://www.instagram.com/luis.break/"
                                  target="_blank"
                                  data-v-38e062e2=""
                                  ><img
                                    width="29"
                                    height="29"
                                    src="https://cdn.gifo.wisestamp.com/s/instagram/EE6A2F/58/circle/border.png"
                                    border="0"
                                    data-v-38e062e2=""
                                /></a>
                              </div>
                              <div
                                class="social"
                                data-v-38e062e2=""
                                style="display: inline-block; padding: 3px 3px"
                              >
                                <a
                                  href="https://www.youtube.com/channel/UCzWIkivSVgOqPYMsOu7pIww"
                                  target="_blank"
                                  data-v-38e062e2=""
                                  ><img
                                    width="29"
                                    height="29"
                                    src="https://cdn.gifo.wisestamp.com/s/youtube/EE6A2F/58/circle/border.png"
                                    border="0"
                                    data-v-38e062e2=""
                                /></a>
                              </div>
                              <div
                                class="social"
                                data-v-38e062e2=""
                                style="display: inline-block; padding: 3px 3px"
                              >
                                <a
                                  href="https://github.com/LuizBreak"
                                  target="_blank"
                                  data-v-38e062e2=""
                                  ><img
                                    width="29"
                                    height="29"
                                    src="https://cdn.gifo.wisestamp.com/s/github/EE6A2F/58/circle/border.png"
                                    border="0"
                                    data-v-38e062e2=""
                                /></a>
                              </div>
                            </div>
                          </td>
                        </tr>

                        <tr data-v-38e062e2="">
                          <td
                            class="content-block"
                            valign="top"
                            align="center"
                            data-v-38e062e2=""
                            style="
                              font-family: sans-serif;
                              vertical-align: top;
                              padding-bottom: 10px;
                              padding-top: 10px;
                              color: rgb(153, 153, 153);
                              font-size: 12px;
                              text-align: center;
                            "
                          >
                            <span
                              class="apple-link"
                              data-v-38e062e2=""
                              style="
                                color: rgb(153, 153, 153);
                                font-size: 12px;
                                text-align: center;
                              "
                              >Marido-en-alquiler, Distrito Nacional, Santo
                              Domingo</span
                            ><br data-v-38e062e2="" />
                            Don't like these emails?
                            <a
                              href="http://www.target-innovations.com"
                              data-v-38e062e2=""
                              style="
                                text-decoration: underline;
                                color: rgb(153, 153, 153);
                                font-size: 12px;
                                text-align: center;
                              "
                              >Unsubscribe</a
                            >.
                          </td>
                        </tr>
                        <tr data-v-38e062e2="">
                          <td
                            class="content-block powered-by"
                            valign="top"
                            align="center"
                            data-v-38e062e2=""
                            style="
                              font-family: sans-serif;
                              vertical-align: top;
                              padding-bottom: 10px;
                              padding-top: 10px;
                              color: rgb(153, 153, 153);
                              font-size: 12px;
                              text-align: center;
                            "
                          >
                            Powered by
                            <a
                              href="http://www.target-innovations.com"
                              data-v-38e062e2=""
                              style="
                                color: rgb(153, 153, 153);
                                font-size: 12px;
                                text-align: center;
                                text-decoration: none;
                              "
                              >Target Innovations</a
                            >
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!-- END FOOTER -->
                  </div>
                </td>
                <td
                  valign="top"
                  data-v-38e062e2=""
                  style="
                    font-family: sans-serif;
                    font-size: 14px;
                    vertical-align: top;
                  "
                >
                  &nbsp;
                </td>
              </tr>
            </table>
          </body>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "service-request-template",
  props: [],
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {
    emailContainer() {
      console.log("emailContainer", this.$store.getters["emailContainer"]);
      return this.$store.getters["emailContainer"];
    },
  },
  mounted() {},
};
</script>
<style scoped>
/* This styling is just to used when generating an inline */
/* 
.social {
  display: inline-block;
  padding: 3px 3px;
}
#customers {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #fd5631;
  color: white;
}
.msg table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

.msg td,
.msg th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.msg tr:nth-child(even) {
  background-color: #dddddd;
}

@media only screen and (max-width: 620px) {
  table.body h1 {
    font-size: 28px !important;
    margin-bottom: 10px !important;
  }

  table.body p,
  table.body ul,
  table.body ol,
  table.body td,
  table.body span,
  table.body a {
    font-size: 16px !important;
  }

  table.body .wrapper,
  table.body .article {
    padding: 10px !important;
  }

  table.body .content {
    padding: 0 !important;
  }

  table.body .container {
    padding: 0 !important;
    width: 100% !important;
  }

  table.body .main {
    border-left-width: 0 !important;
    border-radius: 0 !important;
    border-right-width: 0 !important;
  }

  table.body .btn table {
    width: 100% !important;
  }

  table.body .btn a {
    width: 100% !important;
  }

  table.body .img-responsive {
    height: auto !important;
    max-width: 100% !important;
    width: auto !important;
  }
}
@media all {
  .ExternalClass {
    width: 100%;
  }

  .ExternalClass,
  .ExternalClass p,
  .ExternalClass span,
  .ExternalClass font,
  .ExternalClass td,
  .ExternalClass div {
    line-height: 100%;
  }

  .apple-link a {
    color: inherit !important;
    font-family: inherit !important;
    font-size: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
    text-decoration: none !important;
  }

  #MessageViewBody a {
    color: inherit;
    text-decoration: none;
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
    line-height: inherit;
  }

  .btn-primary table td:hover {
    background-color: #34495e !important;
  }

  .btn-primary a:hover {
    background-color: #34495e !important;
    border-color: #34495e !important;
  }
}
*/
</style>
